import { lazy } from 'react'

export const StayConnectedVariant1 = lazy(
  () => import('./StayConnectedVariant1'),
)
export const StayConnectedVariant2 = lazy(
  () => import('./StayConnectedVariant2'),
)
